import { useState,useEffect } from 'react'
import { useDispatch,useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { TagsInput } from "react-tag-input-component";
import { useJwt } from "../../../../helpers/common";
import  useOrganizationService from '../../../../services/organization';
import OnboardingCarousel from "../OnboardingCarousel";
import { HiBadgeCheck } from "react-icons/hi";
import { ReactMultiEmail } from "react-multi-email";
import 'react-multi-email/dist/style.css';



const InviteTeam = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const JWTdata = useJwt();
    const [selected, setSelected] = useState([]);
    const { inviteUsers } = useOrganizationService();
    const {inviteUsersSuccess,inviteUsersLoading} = useSelector((state: any) => state.organization);
    
    const handleContinue = async() => {
        if(JWTdata.org_id && selected.length){
            if(!inviteUsersLoading){
                await inviteUsers(JWTdata.org_id,{email_list:selected})
            }
        }
        
    }
    const handleBack = () => {
        window.location.href= "/onboarding/profileinfo"
    }

    useEffect(()=>{
        if(inviteUsersSuccess){
            setTimeout(()=>{
                window.location.href= "/workitems" 
            },3000)
            
        }
    },[inviteUsersSuccess])

    const handleSkipClick = () =>{
        window.location.href= "/workitems"
      }


    return (
        <div className={`grid  gap-5  h-full w-full`}>
        <div tabIndex={-1} aria-hidden="true" className="relative p-4 w-full  h-[100vh] flex flex-col items-center justify-center py-24 px-40 overflow-auto">
        <div onClick={handleSkipClick} className=" dark:text-white text-gray-600 text-sm font-light leading-tight absolute top-10 right-10 cursor-pointer" >Skip</div>
        <div className="opacity-50 text-center dark:text-white text-gray-600 text-lg font-normal leading-7 mb-2">Hey, {JWTdata?.username}</div>
                    <div className="opacity-50 text-center dark:text-white text-gray-600 text-lg font-normal leading-7 mb-2">Invite your co-workers</div>
                    <div className="text-center dark:text-white text-gray-600 text-2xl font-normal leading-9 mb-8">Cadence is more helpful when you work with your team members </div>
                    <div className="w-96 mt-8 dark:text-white text-gray-700 text-sm font-normal leading-tight">Email </div>
                        <div className="mt-4 text-center">
                            <div className="w-96 h-32 overflow-auto reactMultiEmail">
                                <ReactMultiEmail
                                    placeholder="Enter email addresses"
                                    emails={selected}
                                    className={"!w-full min-h-[100px]   dark:bg-slate-800 !focus:bg-slate-800  rounded-lg border dark:border-slate-700 "}
                                    onChange={(_emails: string[]) => {
                                        setSelected(_emails);
                                    }}
                                    getLabel={(
                                        email: string,
                                        index: number,
                                        removeEmail: (index: number) => void
                                    ) => {
                                        return (
                                        <div data-tag key={index}>
                                            {email}
                                            <span data-tag-handle onClick={() => removeEmail(index)}>
                                            ×
                                            </span>
                                        </div>
                                        );
                                    }}
                                />
                            </div>
                            
                        </div>
                        
                        <div className="flex mt-12 w-96">
                            <div onClick={handleContinue} className={`w-52 h-9 ml-auto px-5 py-3  ${inviteUsersLoading ? "bg-blue-400" :"bg-blue-700"} rounded-lg justify-center items-center gap-2 inline-flex cursor-pointer`}>
                                <div className="text-white text-base font-medium leading-normal">Send</div>
                            </div>
                        </div>
                </div>
                
        </div>
    )
}

export default InviteTeam;
